import React from 'react'

import { useIntl } from 'react-intl'
import { Box, Alert, Typography } from '@mui/material'

import type { UserGroupItem } from '../UserGroupsList'
import Dialog from '../../../../components/modals/Dialog'

export type ModalUserGroupsDeleteProps = {
	visible: boolean
	onClose: () => void
	onSubmit: () => void
	isSubmitting?: boolean
	group?: UserGroupItem
}

const ModalUserGroupsDelete = ({
	visible,
	onClose,
	onSubmit,
	isSubmitting = false,
	group,
}: ModalUserGroupsDeleteProps) => {
	const { formatMessage } = useIntl()

	const handleClose = (
		event?: object,
		reason?: 'backdropClick' | 'escapeKeyDown'
	) => {
		if (isSubmitting) return

		if (reason === 'backdropClick') return

		onClose()
	}

	return (
		<Dialog
			open={visible}
			onClose={handleClose}
			maxWidth="sm"
			fullWidth
			showActions
			title={formatMessage({
				id: 'user_groups.delete_modal.title',
			})}
			closeButtonProps={{
				text: formatMessage({
					id: 'user_groups.delete_modal.cancel_button',
				}),
				onClick: handleClose,
				disabled: isSubmitting,
			}}
			submitButtonProps={{
				text: formatMessage({
					id: 'user_groups.delete_modal.delete_button',
				}),
				onClick: onSubmit,
				loading: isSubmitting,
				disabled: isSubmitting || !group,
				color: 'error',
			}}
		>
			<Typography variant="h6" sx={{ mb: 2 }}>
				{formatMessage({
					id: 'user_groups.delete_modal.question',
				})}
			</Typography>
			<Alert severity="warning" sx={{ mb: 2 }}>
				{formatMessage({
					id: 'user_groups.delete_modal.warning',
				})}
			</Alert>

			{group && (
				<Box sx={{ mt: 2 }}>
					<Box
						sx={{
							p: 2,
							border: 1,
							borderColor: 'divider',
							borderRadius: 1,
						}}
					>
						<Typography
							variant="subtitle1"
							sx={{ fontWeight: 'bold', mb: 1 }}
						>
							{group.name}
						</Typography>
						<Box display="flex" gap="4px">
							<Typography
								variant="body2"
								color="text.primary"
								fontWeight={600}
							>
								{formatMessage({
									id: 'user_groups.delete_modal.description_label',
								})}
							</Typography>
							{group.description && (
								<Typography variant="body2" color="text.secondary">
									{group.description}
								</Typography>
							)}
						</Box>
					</Box>
				</Box>
			)}
		</Dialog>
	)
}

export default ModalUserGroupsDelete
